export function isErrorOnTheListAlready(priceRangeErrors, errorMessage) {
  return priceRangeErrors.indexOf(errorMessage) !== -1;
}

export function isRangeExceeded(valueToValidate) {
  return Boolean(valueToValidate && valueToValidate.length > 25);
}

export function removeErrorFromTheList(errorMessage, priceRangeErrors, setPriceRangeErrors) {
  if (isErrorOnTheListAlready(priceRangeErrors, errorMessage)) {
    setPriceRangeErrors(priceRangeErrors.filter((item) => item !== errorMessage));
  }
}

export function sendError(setPriceRangeErrors, errorMessage) {
  setPriceRangeErrors((errs) => [...errs, errorMessage]);
  return true;
}

export function isNotInitiantingWithZerro(valueToValidate) {
  return Boolean(valueToValidate && valueToValidate[0].start_quantity !== 0);
}

export function isTheValueNegative(valueToValidate) {
  return Boolean(valueToValidate && valueToValidate < 0);
}

export function isUndefined(valueToValidate) {
  return valueToValidate === undefined;
}

export function isDecimal(valueToValidate) {
  return Boolean(valueToValidate && !Number.isInteger(valueToValidate));
}

export function validationTest(valueToValidate, message, validation, contextValues) {
  const result = validation(valueToValidate);
  const { priceRangeErrors, setPriceRangeErrors } = contextValues;
  if (result) {
    if (isErrorOnTheListAlready(priceRangeErrors, message)) return true;
    return sendError(setPriceRangeErrors, message);
  }
  if (!result && isErrorOnTheListAlready(priceRangeErrors, message)) {
    removeErrorFromTheList(message, priceRangeErrors, setPriceRangeErrors);
  }
  return true;
}
